import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UtilityService } from '../services/utility.service';
import { UpperCasePipe } from '@angular/common';
import { NGXLogger } from 'ngx-logger';
import * as _ from 'underscore'
import { KEYS } from '../constants/keys';
import { Api } from '../constants/api';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

   constructor(
         private router: Router,
        private utilityService:UtilityService,
        private uppercasePipe: UpperCasePipe,private logger:NGXLogger ) {
        }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // loader counting lives in RequestInterceptor (addAPI + finalize) so it also
        // covers cancelled requests — this interceptor only handles error concerns
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                this.errorHandler(error);
                return throwError(error);
            })
        );
    }

    private errorHandler(error: HttpErrorResponse) {
        console.log('Error ', error);
        let msg=error?.error?.message;
        switch (error.status) {
            case 401: {
                this.utilityService.notifier('Session Expired Please Login Again', 'error');
                this.router.navigate(['/']);
                sessionStorage.clear();
                break;
            } 
            case 400: {
                this.setErrorMessage(error);
                break;
            }
            case 411: {
                this.setErrorMessage(error);
                sessionStorage.clear();
                break;
            }
            case 422: {
                this.setErrorMessage(error);
                break;
            }
            case 403:{
                this.utilityService.notifier(error.error.message,'error');
                break;
            }
            case 404: {
                this.utilityService.notifier('API Not Found','error');
                break;
            }
            case 503: {
                this.utilityService.notifier(error.statusText,'error');
                break;
            }
           case 500: {
                if(msg){
                    this.utilityService.notifier(msg, 'error');
                } else {
                    this.utilityService.notifier(error.statusText, 'error');
                }
                break;
             }        
            case 0: {
                this.utilityService.notifier('Seems there is some problem with the server. Try later!', 'error');
            }    
                break;
      
        }
    }

    private setErrorMessage(error:any){
        let errorMsg = error?.error?.message;
        let errorArray = (error?.error?.fieldMessage) ;
        if(errorMsg){
            this.utilityService.notifier(errorMsg, 'error');
        } else {
            errorMsg = this.showFieldWiseErrors(errorArray);
        }
    }

    private showFieldWiseErrors(errorArray: any) {
        let errorMessages:string="";
        let messages=[];
        errorArray?.forEach((element: any, index) => {
            if(!_.contains(messages, element.message)){
              errorMessages = errorMessages+"\n" + (messages.length + 1) + " ]  " + element.message+"";
              messages.push(element.message);
            }
          });
          this.utilityService.notifier(errorMessages, 'error');
    }
}